import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence benign ResizeObserver loop warning from Radix (Select/Dialog) so the
// CRA runtime-error overlay does not block interactions in dev preview.
const silenceRO = (e) => {
  const msg = e?.message || e?.reason?.message || "";
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
  }
};
window.addEventListener("error", silenceRO, true);
window.addEventListener("unhandledrejection", silenceRO, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
